import { createSlice, Dispatch } from "@reduxjs/toolkit";
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
} from "firebase/firestore";
import { enumPublicationStatus } from "src/@types/campaigns";
import { db } from "src/firebase";
import { getPublicationStatus } from "src/utils/getPublicationStatus";

const initialState = {
  isLoading: false,
  campaignBySlug: null,
};

const findCampaignBySlug = createSlice({
  name: "findCampaignBySlug",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.campaignBySlug = null;
    },
    // find slug
    getFindByCampaignIdSuccess(state, action) {
      state.campaignBySlug = action.payload;
      state.isLoading = false;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    getFindByCampaignIdError(state) {
      state.isLoading = false;
    },
  },
});

export default findCampaignBySlug.reducer;
const {
  startLoading,
  getFindByCampaignIdSuccess,
  getFindByCampaignIdError,
  stopLoading,
} = findCampaignBySlug.actions;

const pathToSpaceCampaigns = (id: string) => {
  return `spaces/${id}/space_to_campaigns`;
};

const partToSpace = () => {
  return `spaces/`;
};

export const find_campaign_by_slug = (slug: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(startLoading());
    try {
      const getSpaceRef = collection(db, partToSpace());
      const spaceSnapshot = await getDocs(query(getSpaceRef, limit(200)));
      console.log("[slug] spaces found:", spaceSnapshot.size);

      let matchFound = false;
      for (const spaceDoc of spaceSnapshot.docs) {
        console.log("[slug] space slug:", spaceDoc.data()?.slug, "looking for:", slug);
        if (
          spaceDoc.data()?.slug &&
          spaceDoc.data()?.slug.toLocaleLowerCase() === slug.toLocaleLowerCase()
        ) {
          matchFound = true;
          const getCampaignRef = collection(db, pathToSpaceCampaigns(spaceDoc.id));
          const campaignSnapshot = await getDocs(
            query(getCampaignRef, orderBy("created", "desc"), limit(200))
          );
          console.log("[slug] campaigns found:", campaignSnapshot.size);
          const campaignIdArr: string[] = [];
          campaignSnapshot.forEach((d) => {
            const isActive = getPublicationStatus(
              d.data().publish_start_date,
              d.data().publish_end_date,
              d.data().publish_now,
              spaceDoc.data()?.spaceTimeZone
            );
            console.log("[slug] campaign", d.id, "publish_now:", d.data().publish_now, "status:", isActive);
            if (isActive === enumPublicationStatus.ACTIVE) {
              campaignIdArr.push(d.id);
            }
          });
          if (campaignIdArr.length > 0) {
            dispatch(getFindByCampaignIdSuccess(campaignIdArr));
          } else {
            dispatch(stopLoading());
          }
          break;
        }
      }
      if (!matchFound) {
        console.log("[slug] no space matched slug:", slug);
        dispatch(stopLoading());
      }
    } catch (error) {
      console.error("[slug] error:", error);
      dispatch(getFindByCampaignIdError());
    }
  };
};
